import {apiClient} from "../../AxiosConfig";
import {useState} from "react";
import ConfigStore from "../../store/config-store";
import {useFetchConfigs} from "./useConfigs";

export const useCreateConfig = (
    protocolId,
    serverId,
) => {

    const [isLoading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const createConfig = () => {
        setLoading(true);
        apiClient.post(`/v1/config/create`, {
            server_id: Number(serverId),
            protocol_id: Number(protocolId)
        }).then((response) => {
            if (response.status === 200) {
                ConfigStore.updateConfigs(response.data);
                const fetchConfigs = async () => {
                    const response = await apiClient("/v1/config/");
                    return response.data;
                }
                fetchConfigs().then((data) => {
                    ConfigStore.setConfig(data);
                })
                setIsSuccess(true);
                setLoading(false);
            }
        }).catch((error) => {
            setLoading(false);
        })
    }

    return {isLoading, isSuccess, createConfig}

}